import React from 'react';
import { ResponsiveImage } from '../styles';

export const LocaleFlag = ({ locale }) => {
  const { flag } = locale;

  if (!flag) {
    return null;
  }

  return <ResponsiveImage src={flag} width={24} height={24} />;
};
